import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const INITIAL_STATE = fromJS({
  department: fromJS({}),
  fetching: false,
  posting: false,
  updating: false,
  deleting: false
});

function createDepartment(state, action) {
  return state
    .set('posting', true)
}

function createDepartmentSuccess(state, action) {
  return state
    .set('posting', false)
    .set('message', 'Department was created successfully')
}

function createDepartmentFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to create department'
  }
  return state
    .set('posting', false)
    .set('message', msg)
}

function getDepartmentById(state, action) {
  return state
    .set('fetching', true)
}

function getDepartmentByIdSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('department', fromJS(action.payload.body))
}

function getDepartmentByIdFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to load department'
  }
  return state
    .set('fetching', false)
    .set('message', msg)
}

function updateDepartment(state, action) {
  return state
    .set('updating', true)
}

function updateDepartmentSuccess(state, action) {
  return state
    .set('updating', false)
}

function updateDepartmentFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to update department'
  }
  return state
    .set('updating', false)
    .set('message', msg)
}

function changeDepartmentState(state, action) {
  return state
    .set(action.payload.key, action.payload.value)
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function deleteDepartment(state, action) {
  return state
    .set('deleting', true)
}

function deleteDepartmentSuccess(state, action) {
  return state
    .set('deleting', false)
}

function deleteDepartmentFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to delete department'
  }
  return state
    .set('deleting', false)
    .set('message', msg)
}

export const department = createReducer(INITIAL_STATE, {
  [ActionTypes.CREATE_DEPARTMENT]: createDepartment,
  [ActionTypes.CREATE_DEPARTMENT_SUCCESS]: createDepartmentSuccess,
  [ActionTypes.CREATE_DEPARTMENT_FAILED]: createDepartmentFailed,
  [ActionTypes.GET_DEPARTMENT_BY_ID]: getDepartmentById,
  [ActionTypes.GET_DEPARTMENT_BY_ID_SUCCESS]: getDepartmentByIdSuccess,
  [ActionTypes.GET_DEPARTMENT_BY_ID_FAILED]: getDepartmentByIdFailed,
  [ActionTypes.UPDATE_DEPARTMENT]: updateDepartment,
  [ActionTypes.UPDATE_DEPARTMENT_SUCCESS]: updateDepartmentSuccess,
  [ActionTypes.UPDATE_DEPARTMENT_FAILED]: updateDepartmentFailed,
  [ActionTypes.CHANGE_DEPARTMENT_STATE]: changeDepartmentState,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.DELETE_DEPARTMENT]: deleteDepartment,
  [ActionTypes.DELETE_DEPARTMENT_SUCCESS]: deleteDepartmentSuccess,
  [ActionTypes.DELETE_DEPARTMENT_FAILED]: deleteDepartmentFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/department.js